import { useViewport } from '@farmersdog/corgi-x';
import { Quote } from '../../components';

import styles from './PressBarItem.module.css';

export const PressBarItem = ({
  quote,
}: {
  quote: React.ReactNode | string;
}) => {
  const viewport = useViewport();
  const isMobile = !viewport.md;

  return (
    <div className={styles.item}>
      <Quote
        text={quote}
        variant={isMobile ? 'article-24' : 'article-28'}
        gap={isMobile ? 'md' : 'sm'}
      />
    </div>
  );
};
